import script from "./DigitalBlock.vue?vue&type=script&setup=true&lang=ts"
export * from "./DigitalBlock.vue?vue&type=script&setup=true&lang=ts"

import "./DigitalBlock.vue?vue&type=style&index=0&id=5cfe3702&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5cfe3702"]])

export default __exports__